import "./index.css";
import { NavLink } from "react-router-dom";

function Header() {
  return (
    <div>
      <div>
        {/* <!--NavBar--> */}
        <div className="bs-example">
          <nav className="navbar navbar-expand-md navbar-light fixed-top">
            <a href="/" className="navbar-brand navBrand">
              ETCAN 2021
            </a>
            <button
              type="button"
              className="navbar-toggler"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-expanded="true"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div
              className="collapse navbar-collapse navbar-right  "
              id="navbarCollapse"
            >
              <div className="navbar-nav  ml-auto">
                <div className="p-2">
                  <NavLink exact to="/" className="nav-item nav-link">
                    Home
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/commiittee" className="nav-item nav-link">
                    Committee
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/callforpapers" className="nav-item nav-link">
                    Call for Papers
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/keynotespeaker" className="nav-item nav-link">
                    Keynote Speakers
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/publication" className="nav-item nav-link">
                    Publication
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/submission" className="nav-item nav-link">
                    Submission
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/registration" className="nav-item nav-link">
                    Registration
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/venue" className="nav-item nav-link">
                    Venue
                  </NavLink>
                </div>
                <div className="p-2">
                  <NavLink to="/contact" className="nav-item nav-link">
                    Contact
                  </NavLink>
                </div>
              </div>
            </div>
          </nav>
        </div>
        {/* <!--/NavBar--> */}
      </div>
    </div>
  );
}

export default Header;
